import { useQuery } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";
import type { TrustCallAccountConfig } from "../types";

/** Kept identical to AgentReadOnlyAttribute.DeniedMessage, which the MVC portal shows too. */
export const AGENT_READ_ONLY_MESSAGE =
  "Agents have view-only access to TrustCall. Ask an Admin or Supervisor to make this change.";

export function useAccountConfig() {
  return useQuery<TrustCallAccountConfig>({
    queryKey: ["trustcall", "settings", "monitor-info"],
    queryFn: () => callApi(TC.SETTINGS_MONITOR_INFO, HttpMethod.GET),
    staleTime: 5 * 60 * 1000, // 5 minutes — account config rarely changes
  });
}

/**
 * True when the user holds the trustcall_write permission (Actions / ActionRights, seeded
 * for Supervisor and Admin). The server computes it, so an account that grants its Agents
 * write gets it here without a portal change — and the portal never reads roleId.
 *
 * Defaults to false while the query is in flight: controls render disabled and enable when
 * it resolves, rather than flashing enabled and then locking. TrustCallLayout already calls
 * useAccountConfig(), so the cache is warm on every page but the first.
 */
export function useCanWrite(): boolean {
  return useAccountConfig().data?.canWrite ?? false;
}
